import { Method } from "axios";
import request from "./axios";

function http (method: Method, apiUrl: string, data?: any, {
  codeList,
  headers,
  baseURL,
  withCredentials,
  isProgress,
  responseType,
  initToken = "",
}: any = {}) {
  method = method || "get";
  codeList = codeList || [];
  baseURL = baseURL || "";
  headers = headers || {
    "Content-Type": "application/json; charset=utf-8",
  };
  withCredentials = withCredentials === undefined ? true : !!withCredentials;
  // url
  let url = "";
  if (process.env.NODE_ENV === "development") {
    url = apiUrl;
  } else {
    // url = window.location.origin + window.location.pathname + apiUrl; // document.location.origin + apiUrl
    url = window.location.origin + apiUrl;
  }
  isProgress = isProgress === undefined ? true : !!isProgress;
  responseType = responseType || "json";
  // return promise
  return new Promise<void>((resolve, reject) => {
    request({
      url,
      data,
      method,
      codeList,
      headers,
      baseURL,
      withCredentials,
      isProgress,
      responseType,
      initToken
    })
      .then((res:any) => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default http;
